module.exports = __webpack_public_path__ + "img/report_img_202206.ee375449.png";